// Beginnings & Ends (Pluto): the first and the last star of every word score
// more.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import type { AlignmentDef } from '../types';

export const beginningsAndEnds: AlignmentDef = {
  id: 'beginnings-and-ends',
  planet: 'pluto',
  name: 'Beginnings & Ends',
  text: () => `The first and last star of every word score +${N.beginningsAndEndsPercent}%.`,
  starPercent: (star, c) => (star.index === 0 || star.index === c.nodes.length - 1 ? N.beginningsAndEndsPercent : 0),
};
